import { Text, Badge } from "@fluentui/react-components";
/**
 * To hide the currency in rounded dot formats
 * @param props //numberOfBadges indicates the number of rounded currency circle to be added
 * @returns 
 */
export default function BadgeWrapper(props: { numOfBadges: number; }) {
    return (
        <Text className="account-summary-badge">
            {[...Array(props.numOfBadges)].map((_, index) => (
                <Badge appearance="filled" color="important" size="extra-small" className="currency-circle" key={index}></Badge>
            ))}
        </Text>
    )
}